import Vue from 'vue';
import MiButton from '@/components/mi/MiButton';
import MiDialog from '@/components/mi-dialog/MiDialog';
import MiCalendar from '@/components/mi-calendar/MiCalendar';
import Rating from '@/components/rating/Rating';
import SubjectStatusCount from '@/components/curriculum/SubjectStatusCount.vue';
import LoaderCard from '@/components/loader-card/LoaderCard';
import ProjectSelect from '@/components/ProjectSelect/ProjectSelect';
import Subject from '@/views/Subjects/Subject';
import AuthSetMfa from '@/components/AuthSetMfa/AuthSetMfa.vue';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch.vue';
import PageHeader from '@/components/page-header/PageHeader';
import DeleteButton from '@/components/DeleteButton/DeleteButton.vue';
Vue.component('mi-button', MiButton);
Vue.component('mi-dialog', MiDialog);
Vue.component('mi-calendar', MiCalendar);
Vue.component('rating', Rating);
Vue.component('SubjectStatusCount', SubjectStatusCount);
Vue.component('LoaderCard', LoaderCard);
Vue.component('ProjectSelect', ProjectSelect);
Vue.component('TempSubject', Subject);
Vue.component('AuthSetMfa', AuthSetMfa);
Vue.component('LanguageSwitch', LanguageSwitch);
Vue.component('PageHeader', PageHeader);
Vue.component('DeleteButton', DeleteButton);
